import gameStates    from './gameStates';
import game          from './game';
import score         from './score';
import auction       from './auction';
import player        from './player';
import tricks        from './tricks';
import hands         from './hands';
import highlighting  from './highlighting';
import hiding        from './hiding';
import dds           from './dds';
import turning       from './turning';
import table         from './table';
import parameters    from './parameters';
import studyAuction  from './studyAuction';

export default {

	...gameStates,
	...game,
	...score,
	...auction,
	...player,
	...tricks,
	...hands,
	...highlighting,
	...hiding,
	...dds,
	...turning,
	...table,
	...parameters,
	...studyAuction
};
